export const moment = require('moment-timezone');
moment.tz.setDefault("Asia/Tokyo");

export function unixtimeToFormattedDate(unixtime){
    return moment.unix(unixtime).format("YYYY-MM-DD")
}
export function unixtimeToShortJapaneseFormattedDatetime(unixtime){
    return moment.unix(unixtime).format("MM月DD日HH時mm分")
}
export function unixtimeToShortJapaneseFormattedDate(unixtime){
    return moment.unix(unixtime).format("MM月DD日")
}
export function unixtimeToJapaneseFormattedDate(unixtime){
    return moment.unix(unixtime).format("YYYY年MM月DD日")
}
export function unixtimeToJapaneseFormattedDatetime(unixtime){
    return moment.unix(unixtime).format("YYYY年MM月DD日HH時mm分")
}
export function unixtimeToFormattedShortDate(unixtime){
    return moment.unix(unixtime).format("YY-MM-DD")
}

export function FormattedDateTounixtime(date){
    return moment(date).unix()
}
export function validDateToUnixtime(date){
    return moment(date).unix()
}
export function getUnixtime(){
    return moment().unix()
}
export function unixtimeToFormattedDatetime(unixtime){
    return moment.unix(unixtime).format("YYYY-MM-DD HH:mm")
}
export function unixtimeToDate(unixtime){
    return moment.unix(unixtime).toDate()
}
export function differenceInYearsBetweenTodayAnd(unixtime){
    return moment().diff(moment.unix(unixtime),'years')
}

export function getMoment(){
    return moment
}

